module.exports = __webpack_public_path__ + "media/images/landkit/masks/avatar-group-hover-99066d3a089be07881250b63d83ab969.svg";